/**
 * product-card-hover.js — navegação de fotos no card de produto.
 *
 * Portado 1:1 da TOPBRANDS (assets/card-carousel.js de lá), que já resolve
 * de forma comprovada o mesmo problema que tentamos resolver aqui antes sem
 * sucesso: o swipe sendo "roubado" pelo carrossel PAI (a grade de produtos
 * com swipe_on_mobile, <slider-component> nativo do Dawn, que rola via
 * overflow-x:auto nativo do navegador — sem nenhum listener JS próprio).
 *
 * A técnica: todos os listeners de touch ficam em fase de CAPTURA no
 * document. Fase de captura roda do document PARA BAIXO, ou seja, antes de
 * qualquer listener em fase de bolha de um ancestral (inclusive o scroll
 * nativo não passa por JS, mas o touch-action:pan-y em .card__media-carousel,
 * assets/base.css, é o que garante que o navegador reserve o eixo horizontal
 * pro nosso JS em vez de entregar pro scroll nativo do pai). stopPropagation()
 * na captura impede que QUALQUER listener JS de um carrossel pai (ex: Swiper,
 * se algum dia for usado) sequer veja o gesto.
 *
 * Distinção tap vs swipe: um arrasto horizontal >= SWIPE_THRESHOLD troca a
 * foto; qualquer arrasto horizontal além de TAP_TOLERANCE bloqueia o
 * próximo clique no link do card (blockNextClick), pra um swipe nunca
 * navegar pra PDP sem querer — só um tap de verdade (sem arrasto) navega.
 */
(function () {
  if (window.__tbCardCarouselInit) return;
  window.__tbCardCarouselInit = true;

  var SWIPE_THRESHOLD = 40;
  var TAP_TOLERANCE = 8;

  function getState(root) {
    if (!root._tbCarouselState) {
      root._tbCarouselState = {
        slides: root.querySelectorAll('.card__carousel-slide'),
        dots: root.querySelectorAll('.card__carousel-dot'),
        current: 0
      };
    }
    return root._tbCarouselState;
  }

  function goTo(root, direction) {
    var state = getState(root);
    var slides = state.slides;
    if (!slides || slides.length <= 1) return;
    var dots = state.dots;
    var next = (state.current + direction + slides.length) % slides.length;

    if (slides[state.current]) slides[state.current].classList.remove('is-active');
    if (dots[state.current]) dots[state.current].classList.remove('is-active');

    state.current = next;

    if (slides[state.current]) slides[state.current].classList.add('is-active');
    if (dots[state.current]) dots[state.current].classList.add('is-active');
  }

  function isArrow(target) {
    return target && target.closest && target.closest('[data-carousel-prev], [data-carousel-next]');
  }

  function handleActivate(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var prevBtn = target.closest('[data-carousel-prev]');
    var nextBtn = target.closest('[data-carousel-next]');
    if (!prevBtn && !nextBtn) return;

    var btn = prevBtn || nextBtn;
    var root = btn.closest('.card__inner');
    if (!root || !root.querySelector('.card__media-carousel')) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    goTo(root, prevBtn ? -1 : 1);
  }

  // Click: troca a foto, nunca deixa alcançar link/slider ancestral.
  document.addEventListener('click', handleActivate, true);

  // Neutraliza scripts de drag-to-scroll (ex: slider da home) que escutam
  // touchstart/touchmove/mousedown num ancestral da seta e roubariam o
  // gesto antes de um clique na seta pequena registrar.
  document.addEventListener(
    'touchstart',
    function (event) {
      if (isArrow(event.target)) event.stopPropagation();
    },
    true
  );
  document.addEventListener(
    'touchmove',
    function (event) {
      if (isArrow(event.target)) event.stopPropagation();
    },
    true
  );
  document.addEventListener(
    'mousedown',
    function (event) {
      if (isArrow(event.target)) event.stopPropagation();
    },
    true
  );

  document.addEventListener(
    'touchend',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var btn = target.closest('[data-carousel-prev], [data-carousel-next]');
      if (!btn) return;
      event.stopPropagation();
      event.preventDefault();
    },
    { passive: false, capture: true }
  );

  // ---------------------------------------------------------------
  // Swipe no mobile: arrastar o dedo sobre a foto troca a imagem, sem
  // deixar um arrasto ser confundido com um tap que abre a PDP, e sem
  // deixar o script de drag-to-scroll da grade (que escuta num <ul
  // class="slider slider--desktop/tablet"> ancestral) roubar o gesto.
  // Tudo abaixo roda em fase de CAPTURA, que dispara antes de qualquer
  // listener em fase de bolha nesse <ul> ancestral, então o
  // stopPropagation() aqui tira o gesto do alcance dele por completo
  // durante todo o toque.
  // ---------------------------------------------------------------

  var swipe = null;

  function findSwipeCarousel(target) {
    var cardInner = target && target.closest && target.closest('.card__inner');
    if (!cardInner) return null;
    var carousel = cardInner.querySelector('.card__media-carousel');
    if (!carousel) return null;
    var slideCount = carousel.querySelectorAll('.card__carousel-slide').length;
    if (slideCount <= 1) return null;
    return cardInner;
  }

  function blockNextClick(link) {
    if (!link) return;
    var blocker = function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      link.removeEventListener('click', blocker, true);
    };
    link.addEventListener('click', blocker, true);
    // Limpeza de segurança caso um clique nunca dispare depois deste toque.
    setTimeout(function () {
      link.removeEventListener('click', blocker, true);
    }, 600);
  }

  document.addEventListener(
    'touchstart',
    function (event) {
      if (event.touches.length !== 1) {
        swipe = null;
        return;
      }
      var cardInner = findSwipeCarousel(event.target);
      if (!cardInner) {
        swipe = null;
        return;
      }
      var touch = event.touches[0];
      swipe = {
        cardInner: cardInner,
        startX: touch.clientX,
        startY: touch.clientY,
        axis: null,
        dx: 0
      };
      // Reivindica o gesto imediatamente: não deixa nenhum listener de
      // touchstart de um ancestral (ex: script de drag-to-scroll da grade) vê-lo.
      event.stopPropagation();
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (event) {
      if (!swipe || event.touches.length !== 1) return;
      var touch = event.touches[0];
      var dx = touch.clientX - swipe.startX;
      var dy = touch.clientY - swipe.startY;

      if (!swipe.axis) {
        if (Math.abs(dx) > TAP_TOLERANCE || Math.abs(dy) > TAP_TOLERANCE) {
          swipe.axis = Math.abs(dx) > Math.abs(dy) ? 'horizontal' : 'vertical';
        }
      }

      // Mantém o gesto fora do alcance do script de drag-to-scroll da
      // grade durante toda a duração, independente do eixo.
      event.stopPropagation();

      if (swipe.axis === 'horizontal') {
        // Só assume a ação padrão (scroll/pan horizontal nativo) quando já
        // sabe que é horizontal. O scroll vertical da página fica intocado.
        event.preventDefault();
        swipe.dx = dx;
      }
    },
    { capture: true, passive: false }
  );

  document.addEventListener(
    'touchend',
    function (event) {
      if (!swipe) return;

      // Impede o script de drag-to-scroll da grade de também reagir ao
      // fim deste mesmo gesto (ex: aplicando o próprio momentum).
      event.stopPropagation();

      var cardInner = swipe.cardInner;
      var axis = swipe.axis;
      var dx = swipe.dx;

      if (axis === 'horizontal') {
        if (Math.abs(dx) >= SWIPE_THRESHOLD) {
          goTo(cardInner, dx < 0 ? 1 : -1);
        }
        // Qualquer arrasto horizontal além da tolerância de tap não pode
        // abrir a PDP, mesmo que não tenha sido longo o suficiente pra
        // trocar de foto.
        var link = cardInner.querySelector('a.card__media-link');
        blockNextClick(link);
      }

      swipe = null;
    },
    { capture: true, passive: false }
  );

  document.addEventListener(
    'touchcancel',
    function (event) {
      if (swipe) event.stopPropagation();
      swipe = null;
    },
    { capture: true }
  );
})();
